<template>
  <div class="galleryWrapper" :class="customClass">
    <ul class="gallery">
      <li v-for="(photo, n) in photos" @click="index = n">
        <img
          :src="src(photo.full_image_path, photo.image_url)"
          :alt="photo.image_alt"
        />
      </li>
    </ul>
    <div class="overlay" v-show="index !== null">
      <div class="wrapper">
        <div class="close" @click.self="index = null"></div>
        <div class="arrow prev" @click="slide.prev" v-if="slide"></div>
        <div class="arrow next" @click="slide.next" v-if="slide"></div>
        <ul class="keen-slider" ref="slider">
          <li v-for="(photo, n) in photos" @click="index = n">
            <div class="img">
              <img
                v-if="photo.image_url"
                :src="src(photo.full_image_path, photo.image_url)"
                :alt="photo.image_alt"
              />
            </div>
            <div class="text">
<!--              <p>{{ photo.shop_review.content }}</p>-->
              <p class="meta">
                  <span class="date">{{ setPostedDate(photo) }}</span>
<!--                  <span class="author">by @ユーザー名 {{ photo.shop_review.user.nickname }}</span>-->
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import KeenSlider from 'keen-slider';
export default {
  props: {
    photos: Array,
    imagePath: String,
    customClass: [Array, String]
  },
  data() {
    return {
      slide: null,
      index: null,
    };
  },
  computed: {},
  mounted() {
    const gallery = document.querySelector(".galleryWrapper");
    if (gallery) {
      this.initSlide();
    }
  },
  methods: {
    initSlide(val) {
      const sliderUl = this.$refs.slider;
      if (!sliderUl) return;
      const childrenArray = Array.from(sliderUl.children);
      this.slide = KeenSlider(this.$refs.slider, {
        initial: val,
        slides: {
          perView: 1,
          spacing: 24,
        },
        selector: childrenArray,
      });
    },
    src(full_image_path, image_url) {
      if (full_image_path === undefined) {
        return this.imagePath + image_url;
      } else {
        return full_image_path;
      }
    },
    setPostedDate(photo) {
      if (photo.shop_review) {
        return photo.shop_review.updated_at
      } else {
        return ''
      }
    }
  },
  watch: {
    index(val) {
      this.$nextTick(() => {
        this.initSlide(val);
      });
    },
  },
};
</script>
